const filters = {
  numeric: '0123456789',
  alpha: 'ABCDEFGHIJKLMNOPQRSTUVXZWYabcdefghijklmnopqrstuvxzwy',
  utf8: 'àáâãäçèéêëìíîïñòóôõöùúûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝ'
}

filters.text = filters.alpha + filters.utf8 + ' '
filters.textnumeric = filters.text + filters.numeric
filters.alphanumeric = filters.alpha + filters.numeric
filters.email = filters.alphanumeric + '@._-'
filters.cd_nome = filters.alphanumeric + '-'
filters.rg = filters.numeric + 'X' + 'x'
filters.rg_com_tracos = filters.numeric + 'X' + '-' + '.'
filters.orgao_expedidor = filters.alphanumeric + ' /'
filters.numericComVirgula = filters.numeric + ','
filters.textnumericNoSpace = filters.alpha + filters.utf8 + filters.numeric

export default filters
